import script from "./ShopShoppingCartPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShopShoppingCartPage.vue?vue&type=script&setup=true&lang=ts"

import "./ShopShoppingCartPage.vue?vue&type=style&index=0&id=1913e2bb&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1913e2bb"]])

export default __exports__